import React from 'react'
import { Link } from 'react-router-dom'
import Faq from './Faq'
import Safe from './Safe'
import WhyChoose from './WhyChoose'

const VoiceToTextAndSpeechToSpeech = () => {
  return (
    <>
      <div className="banner-allpage-sec">
        <ul className="breadcrumb">
            <li><Link to="/face-analyser/">Home</Link></li>
            <li>Voice</li>
            <li>Voice: Speech to Speech & Video to Voice Translation, Speech Messenger</li>
        </ul>
        <div className="banner-content-sec text-center">
            <h1 className="first-head">Voice: Speech to Speech & Video to Voice Translation, Speech Messenger</h1>
            <h3 className="second-head"></h3>
        </div>
    </div>
    <Safe/>
    <WhyChoose/>
    <Faq/>
    </>
  )
}

export default VoiceToTextAndSpeechToSpeech
